import styled from 'styled-components';

const DropdownArrow = () => (
	<SVG
		width="17"
		height="16"
		viewBox="0 0 17 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4.97852 6L8.97852 10L12.9785 6"
			stroke="#776FA9"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</SVG>
);

const SVG = styled.svg`
	display: block;
	width: 16px;
	transition: 0.3s;
	transform: translateY(1px);

	path {
		stroke: var(--color-purple-50);
	}
`;

export default DropdownArrow;
